import { combineReducers } from 'redux'
import coupon from './coupon'
import alert from './alert'
import invalid from './invalid'

export default combineReducers({
  coupon,
  alert,
  invalid
})